import React, { useEffect, useContext } from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useAuthStateStore, messageFactory, Topic, } from '@annunciate/core';
import { Oidc } from '@annunciate/web/dist/context';
const setToken = useAuthStateStore.getState().setToken;
export const Purchase = ({ onReady, }) => {
    const { uuid, jwt } = useAuthStateStore((state => {
        return {
            uuid: state.uuid,
            jwt: state.jwt,
        };
    }));
    const ctx = useContext(Oidc);
    useEffect(() => {
        ctx.signInCallback().then((user) => {
            if (user?.id_token) {
                setToken(user.id_token);
            }
            else {
                throw new Error('Unsuccessful login/registration');
            }
        });
    }, []);
    useEffect(() => {
        async function run() {
            if (!uuid) {
                return;
            }
            const u = new URL(window.location.href);
            const params = {};
            u.searchParams.forEach((val, key) => params[key] = val);
            let redirectUri = u.searchParams.get('purchase_redirect_uri');
            if (!redirectUri) {
                throw new Error('Invalid purchase url');
            }
            await messageFactory(Topic.PURCHASE_PRODUCT_SELECTED, {
                redirectUri,
                ...params,
            });
            if (!onReady) {
                const redirect = new URL(redirectUri);
                redirect.searchParams.append('client_reference_id', uuid);
                if (jwt && jwt.email) {
                    redirect.searchParams.append('prefilled_email', jwt.email);
                }
                window.location.replace(redirect.toString());
            }
            else {
                onReady({
                    redirectUri,
                    uuid,
                    email: jwt?.email,
                    params,
                });
            }
        }
        run();
    }, [uuid]);
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, null, "Please wait while we prepare your purchase."),
        React.createElement(LinearProgress, { style: { marginVertical: 10 } })));
};
//# sourceMappingURL=Purchase.js.map